import { navigateConfigChannelMenu } from "modules/Channel/configs/navigationConfig";
import {
  default as PromotionBizzappLogo,
} from "../assets/png/customer.png";
import {
  default as UAABizzappLogo,
} from "../assets/png/merchant.png";

import { navigateConfigUAA } from "../modules/UAA/configs/navigationConfig";

export const appNavigationConfig = [
  { ...navigateConfigUAA, img: UAABizzappLogo },
  { ...navigateConfigChannelMenu, img: PromotionBizzappLogo },
];
